import voluntaryPf from './voluntarypf/voluntarypf.js'
import voluntaryPfHistory from './voluntarypf/voluntarypfhistory.js'
import smtp from './smtp.js'
import crudit from './itdeclaration/crudit.js'
import passwordPolicy from './passwordPolicy.js'
import resetPassword from './resetPassword.js'
import fbpsettings from './fbpsettings.js'
import itdeclarations from './itdeclarations/cruditdeclarations.js'
import eventconfigure from './eventconfigure/eventconfigure.js'
import itsheetandpayslip from './itsheetandpayslip.js'
import managefinancialyear from './managefinancialyear/managefinancialyear.js'
import empleavesdata from './employeeleavesdata/employeeleavesdata.js'
import form24Qacknowledgement from './form24Qacknowledgement/form24Qacknowledgement.js'
import processFNF from './processFNF/processFNF.js'


export default {
    namespaced: true,
    modules: {
        voluntaryPf: voluntaryPf,
        voluntaryPfHistory: voluntaryPfHistory,
        smtp: smtp,
        crudit: crudit,
        itsheetandpayslip: itsheetandpayslip,
        eventconfigure: eventconfigure,
        passwordPolicy: passwordPolicy,
        fbpsettings: fbpsettings,
        itdeclarations: itdeclarations,
        resetPassword: resetPassword,
        empleavesdata: empleavesdata,
        managefinancialyear: managefinancialyear,
        form24Qacknowledgement: form24Qacknowledgement,
        processFNF : processFNF,
    }
}